export const COLUMNS = ["B", "I", "N", "G", "O"] as const;
export type Column = (typeof COLUMNS)[number];

export const COLUMN_COLORS: Record<Column, string> = {
  B: "#1d4ed8",
  I: "#dc2626",
  N: "#e7e5e4",
  G: "#15803d",
  O: "#d97706",
};

export const COLUMN_INK: Record<Column, string> = {
  B: "#f8fafc",
  I: "#f8fafc",
  N: "#18181b",
  G: "#f8fafc",
  O: "#18181b",
};

export function columnFor(num: number): Column {
  if (num <= 15) return "B";
  if (num <= 30) return "I";
  if (num <= 45) return "N";
  if (num <= 60) return "G";
  return "O";
}

export function colRowFor(num: number): { col: number; row: number } {
  const col = Math.min(4, Math.floor((num - 1) / 15));
  const row = (num - 1) % 15;
  return { col, row };
}

export function callLabel(num: number): string {
  return `${columnFor(num)} ${num}`;
}

export function fullDeck(): number[] {
  return Array.from({ length: 75 }, (_, i) => i + 1);
}

export function fisherYates<T>(items: T[]): T[] {
  const next = items.slice();
  for (let i = next.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const a = next[i] as T;
    next[i] = next[j] as T;
    next[j] = a;
  }
  return next;
}

export function pickRandom<T>(items: T[]): { pick: T; rest: T[] } | null {
  if (items.length === 0) return null;
  const index = Math.floor(Math.random() * items.length);
  const pick = items[index] as T;
  const rest = items.filter((_, i) => i !== index);
  return { pick, rest };
}
